/**
 * @module tree/append
 */

/**
 * @typedef {String|Number|DocumentFragment|Element|Text} Content
 */

import fragment from './fragment.js'

/**
 * Adds some contents to the end of the provided target
 * @param {Document|DocumentFragment|Element} target
 * @param {...Content} contents
 */
export default (
  target,
  ...contents
) => {
  const { ownerDocument } = target

  target.appendChild(fragment(contents, ownerDocument))
}
